import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { cloneDeep } from 'lodash'
import { Button, Col, Row, Space } from 'antd'
import { PrimaryButton } from 'Components/button'
import { formValidation, isFormError } from 'helpers/format'
import { selectCurrentUser } from 'Store/user/selector'
import EventModal from 'Components/modal/EventModal'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { ConfirmDailog } from 'Components/modal'
import { ResetPinReq } from 'Store/pos/types'
import { resetStaffPinAPI } from 'Store/pos/api'
import { selectActionEvent } from 'Store/pos/selector'
import { clearEventAction } from 'Store/pos/actions'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  id?: number
}

const ResetPin: React.FunctionComponent<Props> = props => {
  const { onCloseDrawer, visible, currentUser, event, onSuccess = () => {}, id = 0 } = props
  const requireFeild = ['password', 'confirmPassword']
  const initForm = {
    password: [],
    confirmPassword: [],
  } as any
  const [state, setState] = useState('password' as 'password' | 'confirmPassword')
  const [formData, setFormData] = useState(cloneDeep(initForm))
  const [formError, setFormError] = useState([] as string[])
  const [confirmDialog, setConfirmDialog] = useState(false)
  const dispatch = useDispatch()
  const isPasswordState = state === 'password'

  const validateForm = () => {
    const error = formValidation(requireFeild, formData)
    if (formData.password.join('') !== formData.confirmPassword.join('')) {
      error.push('notmatch')
    }
    setFormError([...error])
    return error.length > 0 ? false : true
  }

  const onUpdate = (): void => {
    if (!validateForm()) return
    setConfirmDialog(false)
    const req: ResetPinReq = {
      pin: formData.password.join(''),
      id,
    }
    dispatch(resetStaffPinAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || 0))
  }

  useEffect(() => {
    // clear form data when user cloase drawer
    if (!visible) {
      setFormData(cloneDeep(initForm))
      setFormError([])
      setState('password')
    }
  }, [visible])

  useEffect(() => {
    if (!isPasswordState && formData?.confirmPassword && formData?.confirmPassword.length === 4) {
      validateForm()
    }
  }, [formData])

  const onUpdatePin = (val: string) => {
    const key = isPasswordState ? 'password' : 'confirmPassword'
    const data = formData?.[key] || []
    if (val === 'delete') {
      data.splice(-1, 1)
    } else {
      if (data.length < 4) {
        data.push(val)
      }
      if (data.length === 4) {
        setState('confirmPassword')
      }
    }
    setFormData({
      ...formData,
      [key]: data,
    })
  }

  const onClickReset = () => {
    if (!validateForm()) return
    setConfirmDialog(true)
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    setConfirmDialog(false)
    clearEvent()
    onSuccess()
  }

  const isError = (name: string) => {
    return isFormError(formError, name)
  }

  const title = 'รีเซ็ต PIN ใหม่สำหรับผู้ใช้งาน'
  const activeButton =
    formData?.password &&
    formData?.password.length === 4 &&
    formData?.confirmPassword &&
    formData?.confirmPassword.length === 4
  const FooterContent = (
    <Space size="middle" align="baseline">
      <PrimaryButton text="ยกเลิก" btnType="Cancel" onClick={onCloseDrawer} />
      <PrimaryButton text="ยืนยันการรีเซ็ต PIN" onClick={onClickReset} disabled={!activeButton} />
    </Space>
  )

  const renderButton = (title: any, value: any) => {
    return (
      <ButtonNumber shape="circle" size="large" onClick={() => onUpdatePin(value)}>
        {title}
      </ButtonNumber>
    )
  }

  const onBackState = () => {
    setState('password')
    setFormError([])
    setFormData({
      ...formData,
      confirmPassword: [],
    })
  }

  const renderNumber = () => {
    const number = [] as any
    for (let index = 1; index <= 9; index++) {
      number.push(renderButton(index, index))
    }

    if (isPasswordState) {
      number.push(<span></span>)
    } else {
      number.push(
        <Button type="text" shape="circle" size="large" onClick={onBackState}>
          กลับ
        </Button>,
      )
    }

    number.push(renderButton(0, 0))
    number.push(
      <Button type="text" shape="circle" size="large" onClick={() => onUpdatePin('delete')}>
        ลบ
      </Button>,
    )
    return number
  }

  const numberPad = renderNumber()

  const ConfirmResetDailog = (
    <ConfirmDailog
      title="ยืนยันรีเซ็ต PIN"
      description={`คุณแน่ใจที่จะเปลี่ยนรหัส PIN ของผู้ใช้นี้หรือไม่?`}
      confirmBtnTxt="ยืนยัน"
      isShow={confirmDialog}
      handleOk={onUpdate}
      handleCancel={() => setConfirmDialog(false)}
      loading={event.IsLoading}
    />
  )

  const renderPin = (data: []) => {
    return (
      <Row justify="center" gutter={16}>
        <ColCenter lg={24} md={12} sm={24}>
          <Space>
            {[0, 1, 2, 3].map((item, index) => {
              if ((data && data[item]) || (data && data[item] === 0)) {
                return <PassWord key={index} />
              } else {
                return <PointPass key={index} />
              }
            })}
          </Space>
          {isError('notmatch') && <ErrorMsg>รหัส PIN ไม่ตรงกัน กรุณากรอกข้อมูลใหม่</ErrorMsg>}
        </ColCenter>
      </Row>
    )
  }

  return (
    <DetailDrawer
      title={title}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={FooterContent}
      width={'30%'}
    >
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Title>{isPasswordState ? 'ระบุรหัส PIN ใหม่' : 'ยืนยันรหัส PIN อีกครั้ง'}</Title>
      {renderPin(isPasswordState ? formData?.password || [] : formData?.confirmPassword || [])}
      <Row justify="center" gutter={16}>
        <ColCenter lg={24} md={12} sm={24}>
          <Row gutter={[24, 24]} align="middle">
            {numberPad.map((item: any, index: number) => {
              return (
                <Col span={8} key={index}>
                  {item}
                </Col>
              )
            })}
          </Row>
        </ColCenter>
      </Row>
      {ConfirmResetDailog}
    </DetailDrawer>
  )
}

const PointPass = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  //background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const PassWord = styled(PointPass)`
  border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`

const Title = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h5};
  text-align: center;
  margin-bottom: 10px;
`

const ColCenter = styled(Col)`
  text-align: center;
  margin: 20px 0;
`

const ErrorMsg = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  text-align: center;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`

const ButtonNumber = styled(Button)`
  width: 70px;
  height: 70px;
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h3};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectActionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ResetPin)
